import { render, staticRenderFns } from "./FTab.vue?vue&type=template&id=75425c04&scoped=true"
import script from "./FTab.vue?vue&type=script&lang=ts"
export * from "./FTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75425c04",
  null
  
)

export default component.exports